// Project — a freelance engagement folder. Markdown bodies live in S3; DynamoDB
// holds only the metadata lists/filters need.

export const PROJECT_STATUSES = [
  'draft',
  'active',
  'waiting_client',
  'delivered',
  'archived',
] as const;

export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

/**
 * ProjectItem represents the DynamoDB item for a freelance project.
 * PK: USER#{userId}, SK: PROJECT#{id}
 */
export interface ProjectItem {
  // Primary keys
  pk: string;
  sk: string;
  GSI1PK: string;
  GSI1SK: string;

  // Entity fields
  id: string;
  userId: string;
  companyId: string;
  companyName: string; // denormalized for list cards; refreshed on company rename
  name: string; // 1–200
  slug: string;
  status: ProjectStatus;
  dueDate?: string; // YYYY-MM-DD
  tags: string[];
  openQuestionCount: number;
  attachmentCount: number;
  diagramCount: number;

  // Metadata
  createdAt: string;
  updatedAt: string;
  version: number;
}

/** Input for creating a project. */
export interface ProjectCreateInput {
  companyId: string;
  name: string;
  dueDate?: string;
  status?: ProjectStatus;
  tags?: string[];
}

/** Input for updating a project. */
export interface ProjectUpdateInput {
  expectedVersion: number;
  name?: string;
  companyId?: string;
  dueDate?: string | null; // null clears the date
  status?: ProjectStatus;
  tags?: string[];
}

/** Public API shape (keys stripped). */
export type ProjectResponse = Omit<ProjectItem, 'pk' | 'sk' | 'GSI1PK' | 'GSI1SK'>;
